import React from 'react';

type TSliderProps = {
    value: number;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onInput?: (e: React.FormEvent<HTMLInputElement>) => void;
    disable: boolean;
    min?: number;
    max?: number;
}

const Slider = ({ value, onChange, onInput, disable, min = 1, max = 100 }: TSliderProps) => {
    return (
        <div className="tw-w-full tw-max-w-md tw-mx-auto">
            <input 
                disabled={disable} 
                step="1" 
                type="range" 
                min={min} 
                max={max} 
                value={value} 
                onChange={onChange}
                onInput={onInput} // Add the onInput handler
                className="slider-thumb" 
            />
        </div>
    );
};

export default Slider;